
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  getMonitorGunStatus,
  getMonitorPileGrid,
  getMonitorTotalPileGun
} from "@/api/api-operation-service";
import { GunStatusColorEnum, PileStatusEnum } from "./gun-stauts-enum";
import gunDetail from "./components/gun-detail.vue";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import infoTitle from "@/components/info-title/info-title.vue";
import selectStation from "@/components/select-station/select-station.vue";
@Component({
  components: {
    gunDetail,
    piSelectOper,
    "pi-info-title": infoTitle,
    "pi-select-station": selectStation
  }
})
export default class PiSiteMonitor extends Vue {
  private filterStatus = "";
  private filterStatusNumber = 0;
  private setNum: objAny = {};
  private sortKey = 0;
  private isShowGunList = true;
  private gunStatusList: objAny = [];
  overviewInfo: objAny = {};
  private dataClassify: objAny = {};
  private pileData: objAny = {};
  private allPileData: objAny = {};
  privilegeVoObj: objAny = {};
  isInit = false;
  /**
   * 点击枪数据
   */
  activateGunInfo: objAny = {};
  /**
   * 点击枪数据对应的桩Id
   */
  activatePileInfo: objAny = {};
  GunStatusColorEnum = GunStatusColorEnum;
  PileStatusEnum = PileStatusEnum;
  pileToTypePkid = {
    pileAc: 12361,
    pileDc: 1038
  };

  /**
   * 不同枪口装填对应不同的class
   */
  statusMapClass = {
    free: "pi-free",
    putGun: "pi-put-gun",
    full: "pi-charge-full",
    charge: "pi-charge",
    offline: "pi-offline",
    fault: "pi-fault",
    forbidden: "pi-forbidden",
    order: "pi-order"
  };

  /**
   * 不同枪类型对应图片
   */
  typeMapPic = {
    pileDc: this.$config.host + "/images/dc-stake.png",
    pileAc: this.$config.host + "/images/ac-stake.png"
  };
  private formInline: objAny = {
    oprPkId: "",
    globalSearch: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    merchantPkId: "",
    staPkId: ""
  };

  provinceList: objAny[] = [];
  cityList: objAny[] = [];
  provinceId = "";
  cityId = "";

  public changeCity(): void {
    this.formInline.regionId = this.cityId;
    this.formInline.staPkId = "";
  }

  changeMerchant(): void {
    this.formInline.staPkId = "";
  }

  async getMonitorGunStatusApi(): Promise<void> {
    const ret = await getMonitorGunStatus(this.formDataNull(this.formInline));
    if (ret.status == this["$config"].apiStatus) {
      this.gunStatusList = this.gunStatusList.map((item: objAny) => {
        const fItem = ret.data.filter((fCItem: objAny) => {
          return fCItem.status === item.status;
        });
        item.gunAmount = fItem.length ? fItem[0].gunAmount : item.gunAmount;
        return item;
      });
    }
  }
  /**
   * 获取站点 枪汇总数据
   */
  async getMonitorTotalPileGunData(): Promise<void> {
    const ret = await getMonitorTotalPileGun(
      this.formDataNull(this.formInline)
    );
    if (ret.status == this["$config"].apiStatus) {
      this.overviewInfo = ret.data[0] || {};
    }
  }

  /**
   * 获取桩列表
   */
  async getPileDataApi(): Promise<void> {
    const ret = await getMonitorPileGrid(this.formDataNull(this.formInline));
    if (ret.status == this["$config"].apiStatus) {
      this.allPileData = ret.data;
      this.pileData = JSON.parse(JSON.stringify(ret.data));
      this.onSortGun(this.sortKey, this.pileData);
    }
  }

  /**
   * 排序枪
   * @param sort 排序方式
   * @param data 枪数据
   */
  onSortGun(sort: number, data: objAny): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    const sortKey: "deviceType" | "power" = sort ? "power" : "deviceType";
    const sortData = function(key: "deviceType" | "power") {
      const listNoRepeat = data.filter(function(
        val: objAny,
        index: objAny,
        array: objAny
      ) {
        const fIndex = array.findIndex((item: objAny) => {
          return item[key] === val[key];
        });
        return fIndex === index;
      });
      that.dataClassify = listNoRepeat.map((item: objAny) => {
        const text = item[key] ? item[key] + "kW" : "";
        const cItem: objAny = {
          name: key === "power" ? text : item["deviceTypeDesc"],
          data: data.filter((cItem: objAny) => {
            let itemShow = true;
            if (that.filterStatus != "" && cItem.gunList) {
              itemShow = false;
              cItem.gunList.map((gun: objAny) => {
                if (gun.gunStatus == that.filterStatus) {
                  itemShow = true;
                }
              });
            }
            cItem.itemShow = itemShow;
            return item[key] == cItem[key];
          })
        };
        return cItem;
      });
    };
    sortData(sortKey);
  }

  /**
   * 改变排序方式
   */
  handleSortKeys(): void {
    this.onSortGun(this.sortKey, this.pileData);
  }

  /**
   * 返回到枪列表
   */
  goToGunList(isShow: boolean, pileInfo: objAny, gunInfo: objAny): void {
    this.isShowGunList = isShow;
    if (pileInfo && !pileInfo.serialNumber) {
      pileInfo.serialNumber = "";
    }
    if (pileInfo && !pileInfo.deviceTypeDesc) {
      pileInfo.deviceTypeDesc = "";
    }
    this.activateGunInfo = gunInfo;
    this.activatePileInfo = pileInfo;
  }

  public formDataNull(data: objAny): objAny {
    const json: objAny = {};
    for (const i in data) {
      if (data[i] !== "" && data[i] !== undefined) {
        json[i] = data[i];
      }
    }
    return json;
  }

  onClickSearch(): void {
    this.filterStatus = "";
    this.getPileDataApi();
    this.getMonitorTotalPileGunData();
  }
  public filterGun(status: string, num: number): void {
    this.filterStatus = status;
    this.filterStatusNumber = num || 0;
    this.onSortGun(this.sortKey, this.pileData);
  }
  mounted(): void {
    // this.privilegeVoObj = this.$route.meta?.privilegeVoObj;
    // if (this.formInline.oprPkId) {
    this.isInit = true;
    this.onClickSearch();
    // }
  }
}
